$(document).on("turbolinks:load", function () {

  if($('#js-report-field-type-select').is('*')){
    $('#js-report-field-type-select').on('change', function(){
      displayOptions();
    });
  }

});

function displayOptions() {
    if (
      $("#js-report-field-type-select option:selected").val() == "multiple_option" ||
      $("#js-report-field-type-select option:selected").val() == "single_option"
    ) {
      $("#js-field-options input").prop('disabled', false);
      $("#js-field-options").slideDown("fast");
    } else {
      $("#js-field-options").slideUp("fast");
      $("#js-field-options input").prop('disabled', true);
    }
}